import React, { useEffect, useState } from "react";
import Recaptcha from "react-recaptcha";

const GRecaptcha = ({
    siteKey,
    setRecapcha,
    recaptchaInstance,
    setRecaptchaInstance,
}) => {
    useEffect(() => {
        if (recaptchaInstance) {
            recaptchaInstance.execute();
            setInterval(() => {
                recaptchaInstance.execute();
            }, 70000);
        }
    }, [recaptchaInstance]);

    return (
        <Recaptcha
            ref={(e) => setRecaptchaInstance(e)}
            sitekey={siteKey}
            size="invisible"
            verifyCallback={(response) => {
                setRecapcha(response);
            }}
        />
    );
};

export default GRecaptcha;
